import { render } from "./BarangayMap.vue?vue&type=template&id=560963e7&scoped=true"
import script from "./BarangayMap.vue?vue&type=script&lang=js"
export * from "./BarangayMap.vue?vue&type=script&lang=js"

import "./BarangayMap.vue?vue&type=style&index=0&id=560963e7&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560963e7"]])

export default __exports__